export const RequestType = "Request Contact Update - Self Service";
